<template>
	<span :endTime="endTime" :endText="endText">
		<slot>{{ content }}</slot>
	</span>
</template>

<script>
export default {
	data() {
		return {
			content: '',
		}
	},
	props: {//接收父组件的数据
		endTime: { type: String, default: '' },
		endText: { type: String, default: '00:00' },
		type: { type: Number, default: 1 },
	},
	watch: {//监听时间的变化
		endTime() {
			this.countdowm(this.endTime)
		}
	},
	mounted() {
		this.countdowm(this.endTime)
	},
	methods: {
		countdowm(timestamp) {
			let self = this;
			let timer = setInterval(function () {
				// 获取当前时间戳	
				let nowTime = new Date().getTime();
				// 如果传入的是秒，需要转换为毫秒
				let endTime =self.endTime;
				// 计算时间差
				let t = endTime - nowTime;
				if (t > 0) {
					self.$emit("countdown_show", true)
					let day = Math.floor(t / 86400000);
					let hour = Math.floor((t / 3600000) % 24);
					let min = Math.floor((t / 60000) % 60);
					let sec = Math.floor((t / 1000) % 60);
					hour = hour < 10 ? "0" + hour : hour;
					min = min < 10 ? "0" + min : min;
					sec = sec < 10 ? "0" + sec : sec;
					let format = '';

					if (self.type == 1) {
						if (day > 0) {
							format = `${day} 天 ${hour} 时 ${min} 分 ${sec} 秒`;
						}
						if (day <= 0 && hour > 0) {
							format = `${hour} 时 ${min} 分 ${sec} 秒`;
						}
						if (day <= 0 && hour <= 0) {
							format = `${min} 分 ${sec} 秒`;
						}
					} else {
						format = `${min}:${sec}`;
					}

					self.content = format;
				} else {
					clearInterval(timer);
					self.content = self.endText;
					self.$emit("countdown_show", false)
				}
			}, 1000);
		}
	}
}
</script>
<style></style>